import React, { ReactNode } from 'react';

import clsx from 'clsx';

import { WarningImage } from 'assets/icons';
import { InfoIcon } from 'assets/images';
import FormHeader from 'components/FormHeader';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';
import { Theme } from 'enums/Theme';
import TabsPanel, { TabsPanelProps } from 'pages/Dashboard/TabsPanel';

import styles from './DashboardFormHeader.module.scss';

interface DashboardFormHeaderProps {
  mainMessage?: string | JSX.Element;
  infoMessage?: string;
  isSeparate?: boolean;
  tabsPanelProps?: TabsPanelProps;
  isDefaultStyles?: boolean;
  percent?: number | ProgressBarStatus;
}

const MESSAGE_FROM_HFS = 'Message from HFS:';

const DashboardFormHeader = ({
  mainMessage,
  infoMessage,
  isSeparate,
  isDefaultStyles,
  tabsPanelProps,
  percent,
}: DashboardFormHeaderProps) => {
  return (
    <div>
      <FormHeader
        classNameHeader={clsx(
          !isDefaultStyles && styles.formHeader,
          isDefaultStyles && styles.notSeparatedFormHeader,
          isSeparate && styles.separatedFormHeader,
        )}
        theme={Theme.Dark}
        title={isDefaultStyles ? mainMessage : undefined}
        percent={percent}
      >
        {!isDefaultStyles && (
          <>
            <div className={styles.largeTitle}>Welcome to Your HFS Loan Portal</div>
            {mainMessage && (
              <div className={styles.mainInfoMessageContainer}>
                <div className={styles.formHeaderTitle}>
                  <WarningImage />
                  <div>{MESSAGE_FROM_HFS}</div>
                </div>
                <div className={clsx(styles.formHeaderMessageText, styles.mainMessage)}>{mainMessage}</div>
              </div>
            )}
            {infoMessage && (
              <div className={styles.otherInfoMessageContainer}>
                <InfoIcon className={styles.infoIcon} />
                <div className={styles.formHeaderMessageText}>{infoMessage}</div>
              </div>
            )}
          </>
        )}
      </FormHeader>
      {tabsPanelProps && <TabsPanel {...tabsPanelProps} />}
    </div>
  );
};

export default DashboardFormHeader;
